/* eslint
    no-empty-function: "warn"
*/

import { element, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';

namespace Meds.Modules {
  @invoke
  class PrescriptionScrollState {
    static yScrollKey: string = 'scroll-y-state';

    static bannerHeightKey: string = 'mobile-banner-height';

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'save-scroll-state',
          callback: this.SaveScrollState
        }
      });

      window.onload = (event) => {
        this.ApplySavedScrollState();
      };
    }

    private SaveScrollState = (e: any) => {
      const clickedElement = e.target as HTMLElement;
      const openPrescriptionMenuItem = element(
        '[data-prescription-open-menu]'
      ) as HTMLDetailsElement;
      let compensation = 0;

      if (openPrescriptionMenuItem && clickedElement) {
        if (
          openPrescriptionMenuItem.offsetTop < clickedElement.offsetTop &&
          window.scrollY > 0
        ) {
          if (openPrescriptionMenuItem.offsetTop > window.scrollY) {
            compensation = window.scrollY;
          } else {
            const headerHeight = element('header')?.offsetHeight ?? 0;
            compensation = openPrescriptionMenuItem.offsetTop - headerHeight;
          }
        } else {
          compensation = window.scrollY;
        }
      }
      sessionStorage.setItem(
        PrescriptionScrollState.yScrollKey,
        compensation.toString()
      );
    };

    private ApplySavedScrollState = () => {
      const yPos = sessionStorage.getItem(PrescriptionScrollState.yScrollKey);

      if (yPos) {
        window.scrollTo(0, Number(yPos));
        sessionStorage.removeItem(PrescriptionScrollState.yScrollKey);
      }
    };
  }
}
